/* Voyage Aquarelle — bouton clair/foncé + apparition au défilement */
(function () {
  var root = document.documentElement;
  var mq = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;

  function currentTheme() {
    var t = root.getAttribute('data-theme');
    if (t === 'light' || t === 'dark') return t;
    return mq && mq.matches ? 'dark' : 'light';
  }

  function syncButtons() {
    var dark = currentTheme() === 'dark';
    document.querySelectorAll('[data-va-theme-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', dark ? 'true' : 'false');
      btn.setAttribute('aria-label', dark ? 'Passer en mode clair' : 'Passer en mode foncé');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-va-theme-toggle]');
    if (!btn) return;
    var next = currentTheme() === 'dark' ? 'light' : 'dark';
    root.setAttribute('data-theme', next);
    try { localStorage.setItem('va-theme', next); } catch (err) {}
    syncButtons();
  });

  if (mq && mq.addEventListener) mq.addEventListener('change', syncButtons);
  syncButtons();

  /* Apparition douce au défilement.
     Sécurité : seuls les éléments sous la ligne de flottaison sont masqués,
     et tout est révélé si l'observateur ne répond pas. */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;
  if (reduce || designMode || !('IntersectionObserver' in window)) return;

  var fired = false;
  var io = new IntersectionObserver(function (entries) {
    fired = true;
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
    });
  }, { rootMargin: '0px 0px -5% 0px', threshold: 0 });

  function revealAll() {
    document.querySelectorAll('.va-pending').forEach(function (el) { el.classList.add('is-in'); });
  }

  function observe(scope) {
    (scope || document).querySelectorAll('[data-va-reveal]:not(.va-pending)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.95) return; /* déjà visible : on n'y touche pas */
      el.classList.add('va-pending');
      io.observe(el);
    });
  }
  observe();
  setTimeout(function () { if (!fired) revealAll(); }, 2500);
  document.addEventListener('shopify:section:load', function (e) { observe(e.target); });
})();
